<div fxLayout="column" fxLayoutGap="5px">

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <span class="mat-subheading-1 boldest">{{"endorder.guaranted-payment"|translate|capitalize}}</span>
    <span class="mat-caption boldest primary-ico clicked" *ngIf="cardClient$ &&cardClient$.length>0 "
      (click)="showCardList =! showCardList; $event.stopPropagation();selectPaymentEvent.emit('secure_counter')">{{"button.modify"|translate}}</span>
  </div>

  <div *ngIf="!showCardList">
    <!-- <div > -->

    <mat-list role="list" *ngIf="cardClient$">

      <mat-list-item class="rad-bord clicked">

        <div matLine>
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" fxFlex>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <img src=" {{cardClient$.card.logo_src}}" class="rad-bord logo-card"
                *ngIf="cardClient$.card.brand !== 'visa' && cardClient$.card.brand !== 'mastercard'">
              <img src="assets/img/refonte-logo/VISA.png"  class="h-10" *ngIf="cardClient$.card.brand === 'visa'">
              <img src="assets/img/refonte-logo/MASTERCARD.png"  class="h-10"
                *ngIf="cardClient$.card.brand === 'mastercard'">
              <span class="mat-subheading-1 boldest">{{cardClient$.card.brand | capitalize}}</span>
            </div>
            <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** **** {{cardClient$.card.last4}}</span>
            <span class="mat-subheading-1" style="color:grey" fxHide fxShow.xs>**** {{cardClient$.card.last4}}</span>
          </div>
        </div>

      </mat-list-item>

    </mat-list>


    <div *ngIf="!cardClient$">
      <div> <span class="mat-subheading-1" *ngIf="clientCards$ && clientCards$.length ===0">{{"endorder.addPaymentMethod"|translate}}</span> </div>
      <div> <span class="mat-subheading-1" *ngIf="clientCards$ && clientCards$.length > 0">{{"endorder.selectPaymentMethod"|translate}}</span> </div>
    </div>

  </div>

  <mat-list role="list" *ngIf="showCardList">
    <!-- <mat-list role="list" > -->

    <mat-list-item *ngFor="let card of clientCards$; let index = index; let last = last;" class="rad-bord clicked"
      [class.isSelected]="cardClient$ && card.id === cardClient$.id" (click)="selectCardClient(card);$event.stopPropagation();">
      <!-- <mat-list-item *ngFor="let card of clientCards$; let index = index; let last = last;" class="rad-bord clicked"
      (click)="selectCardClient(card);$event.stopPropagation();"> -->

      <div matLine>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" fxFlex>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <img src=" {{card.card.logo_src}}" class="rad-bord logo-card"
              *ngIf="card.card.brand !== 'visa' && card.card.brand !== 'mastercard'">
            <img src="assets/img/refonte-logo/VISA.png" class="rad-bord h-10" *ngIf="card.card.brand === 'visa'">
            <img src="assets/img/refonte-logo/MASTERCARD.png" class="rad-bord h-10" *ngIf="card.card.brand === 'mastercard'">
            <span class="mat-subheading-1 boldest">{{card.card.brand | capitalize}}</span>
          </div>
          <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** **** {{card.card.last4}}</span>
          <span class="mat-subheading-1" style="color:grey" fxHide fxShow.xs>**** {{card.card.last4}}</span>
        </div>
      </div>

      <mat-icon mat-icon-button class="dark-ico" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation();"
        *ngIf="showDelete">
        more_vert</mat-icon>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openDialDeletCard(card, index); $event.stopPropagation();" angulartics2On="click"
          angularticsAction="openDeleteDialog" angularticsCategory="paymentMethods">{{"basket.delete" |
          translate}}</button>
      </mat-menu>

    </mat-list-item>

    <mat-list-item class="rad-bord clicked" *ngIf="clientCards$ && clientCards$.length ===0">
      <div matLine> <span class="mat-subheading-1">{{"endorder.addPaymentMethod"|translate}}</span> </div>
    </mat-list-item>

  </mat-list>


</div>

<div *ngIf="clientCards$" fxLayout="row" fxLayoutAlign="end center" [ngStyle]="{'margin-top' : clientCards$.length > 0 ? '10px' : '0px'}">

  <!-- TODO ANTHONY
    <button mat-stroked-button (click)="openDialCardSca()" angulartics2On="click" angularticsAction="openCreateDialog" angularticsCategory="paymentMethods">
      {{"dialogs.cards.add-card" | translate | uppercase}}
  </button> -->

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'CardBackOfficeClientComponent.loaderGetcard'|translate"
  [type]="'line'">
</app-popup-loader>
